"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxInput = CheckBoxInput;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function CheckBoxInput({
  control,
  field,
  label
}) {
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange,
        value = false,
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
        control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          size: "medium",
          value: value,
          onChange: onChange,
          inputProps: {
            'aria-label': label
          }
        }),
        label: label
      });
    }
  });
}